export const hosts = new Set([
  'fashionunited.com.ar',
  'au.fashionunited.com',
  'fashionunited.be',
  'fashionunited.be/fr',
  'fashionunited.ca',
  'fashionunited.ca/fr',
  'fashionunited.ch',
  'fashionunited.cl',
  'cn.fashionunited.com',
  'fashionunited.co',
  'fashionunited.de',
  'fashionunited.es',
  'fashionunited.fr',
  'fashionweekweb.com',
  'internationalfashionjobs.com',
  'fashionunited.in',
  'fashionunited.info',
  'fashionunited.it',
  'fashionunited.mx',
  'fashionunited.nl',
  'fashionunited.nz',
  'fashionunited.com.pe',
  'ru.fashionunited.com',
  'fashionunited.uk',
  'fashionunited.com',
]);

const hasLocalNews = (host) => hosts.has(host);

export default hasLocalNews;
